import React, { useEffect, useState, useRef, useCallback } from "react";
import html2pdf from 'html2pdf.js'
import {
    getCustomFormById,
    getCustomFormTitleById,
    updateField,
    calcAge,
    deleteFormQuestion,
    updateLocalSequence,
    updateDBQuestionSequence,
    updateFormComplete,
    updateCompleteStatus,
    setMultiFormsModal
} from "../../state/customFormsSlice";
import { useSelector, useDispatch } from "react-redux";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Button from "react-bootstrap/Button";
import {envAwarePost} from '../../util/util'
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch';
import Container from "react-bootstrap/Container";
import { useParams } from "react-router";
import QuestionModal from "./QuestionModal"
import debounce from "lodash.debounce"
import classes from "../parQ/ParQ.module.css"
import classesForms from "./customForms.module.css"
import "react-datepicker/dist/react-datepicker.css"
import CenteredLoader from '../CenteredLoader/CenteredLoader';
import { 
    selectClientsById, 
    getAllClients, 
    selectTrainerParam 
} from '../users/usersSlice';
import Table from "react-bootstrap/Table";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";

import SignatureModal from "./SignatureModal";

import SignatureCanvas from 'react-signature-canvas'
import useCurrentUser from '../../hooks/useCurrentUser'
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"
import classesMetricList from "../MetricList/MetricList.module.css"
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {useMultiFormsModal} from "./hooks"

import {updateProgramAssign} from '../FinancialsDashboard/Packages/packagesSlice'

import {useCustomForms} from './hooks'
import {usePrograms} from '../programs/hooks'

const mapFormToQuestionSequence = form => {
    const result = [];
    let i = 1
    Object.entries(form).forEach(([k,questions])=>{
        questions.forEach((question,j)=>{
            result.push({
                id:question.question_id,
                sequence:i,
                question_number:j+1,
                category_id:question.category_id
            })
            i+=1
        })
    })
    return result;
}

function FormEditor ({form,proceed,isLastForm=false,clientId}) {
	console.log(form,clientId)
    const dispatch = useDispatch()
    const history = useHistory()

    const formId = form.form_id

   	const user = useCurrentUser()

   	clientId = (
        user.account_type === 'client'
        ? user.user_id_number
        : clientId
    )

    const isTrainer = useSelector(state => state.users.current_user.account_type === "trainer");
    const isGym = useSelector(state => state.users.current_user.account_type === "gym");

    const editingMode = clientId === "edit";

    const isTrainerOrGym = isTrainer || isGym

    const isTrainerOrGymEditing = isTrainerOrGym && editingMode

    const isClient = user.account_type === 'client'
    const isPartOfGym = user.gym_id != 0

    const singleForm = useSelector(state => state.customForms.singleForm)
    const formTitle = useSelector(state => state.customForms.formTitle)
    const formOwnerId = useSelector(state => state.customForms.owner_id)
    const completeStatus = useSelector(state => state.customForms.complete)
    const defaultForm = useSelector(state => state.customForms.default_form)

    const [showConfirmComplete, setShowConfirmComplete] = useState(false)
    const [loadFormComplete, setLoadFormComplete] = useState(false)
    const [loadingForm, setLoadingForm] = useState(false);


    useEffect(() => {
        setLoadingForm(true)
        let payload = {
            action: "getCustomFormById",
            form_id: formId,
        }

        if (isTrainerOrGym) {
            payload.client_user_id = clientId
        }

        dispatch(getCustomFormById(payload))
            .then(res => {
                setLoadingForm(false)

            });

        let payloadTitle = {
            action: "getCustomFormTitleById",
            form_id: formId,
        }
        dispatch(getCustomFormTitleById(payloadTitle))
    }, [formId])


    //signature canvas
    const sigCanvas = useRef();

    function clearSigCanvas() {
        sigCanvas.current.clear();
    }

    const statusDispatch = useApiStatusDispatch();

    const [showQuestionModal, setShowQuestionModal] = useState(false);
    const [showSignatureModal, setShowSignatureModal] = useState(false);

    const [questionToEdit, setQuestionToEdit] = useState(null)

    const [questionDeleteLoad, setQuestionDeleteLoad] = useState(false);


    function handleQuestionDelete(question_id, category_name, question_user_id_number, category_id, form_id) {
        setQuestionDeleteLoad(true)
        let payload = {
            action: "deleteFormQuestion",
            question_id,
            category_name,
            question_user_id_number,
            category_id,
            form_id
        }
        if (window.confirm("Are you sure you want to delete this question?")) {
            statusDispatch(deleteFormQuestion(payload), "question", "delete").then(
                res => {
                    setShowQuestionModal(false)
                    setQuestionToEdit(null);
                    setQuestionDeleteLoad(false)
                }
            )
        }
    }



    function updateDB(payload) {
        dispatch(updateField(payload))
    }

    const debouncedUpdateDB = useCallback(debounce((payload) =>
        updateDB(payload), 500), [])

    function print() {
        let sideNav = document.querySelector(".App_SideContent__Rs8PF")
        let mainLayout = document.querySelector(".App_MainLayout__2X78D")

        mainLayout.style.height = "initial"
        sideNav.style.display = "none";
        window.print();
        mainLayout.style.height = "100vh"
        sideNav.style.display = "initial";
    }

    const download = async () => {
        var element = document.getElementById('formDownloadContainer')
        var opt = {
            pagebreak: { mode: 'avoid-all' },
            margin:       0.5,
            filename:     `${formTitle}.pdf`,
            image:        { type: 'jpeg', quality: 0.98 },
            html2canvas:  { scale: 1 },
            jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
        };

        let sideNav = document.querySelector(".App_SideContent__Rs8PF")
        let mainLayout = document.querySelector(".App_MainLayout__2X78D")

        const title = document.getElementById('formTitle')
        const hideForDownload = document.getElementsByClassName('hideForDownload')

        title.style.fontSize = '18px'
        title.style.marginBottom = '0'
        mainLayout.style.height = "initial"
        sideNav.style.display = "none"

        hideForDownload.forEach(el=>{
            el.style.display = 'none'
        })

        html2pdf().set(opt).from(element).save().then(()=>{
            mainLayout.style.height = "100vh"
            sideNav.style.display = "initial"

            title.style.fontSize = 'initial'
            title.style.marginBottom = 'initial'

            hideForDownload.forEach(el=>{
                el.style.display = 'initial'
            })
        })
    }

    function formatDate(dt) {
        let newDate = dt.getFullYear() + "-" + ((dt.getMonth() + 1) >= 10 ? dt.getMonth() + 1 : "0" + (dt.getMonth() + 1)) + "-" + dt.getDate();
        return newDate;
    }

    let currentDate = formatDate(new Date())

    function handleFormComplete() {
        setLoadFormComplete(true);
        const payload = {
            complete_status: "1",
            form_id: formId,
            client_id: (
                user.account_type === 'client'
                ? user.user_id_number
                : clientId
            ),
            updateFormComplete: formId == "0" ? "1" : "0",
        }
        statusDispatch(updateFormComplete(payload), "form", "complete")
            .then(res => {
                setLoadingForm(true)
                dispatch(updateCompleteStatus(true));
                setLoadFormComplete(false);
                setShowConfirmComplete(false);
                proceed()
            })
    }

    function priorityFieldsLoop(priorityFields, question, questionNumber, category) {
        let questionText = question.question;
        return (
            <>
                {isTrainerOrGymEditing && <td >
                    {user.user_id_number == formOwnerId &&
                        <div className="d-flex justify-content-center mt-1" style={{ fontSize: "1.2rem" }}>
                            <div
                                className="mr-3 text-danger"
                                style={{
                                    fontSize: "1.2rem", fontWeight: "bold", cursor: "pointer"
                                }}
                                onClick={() => { handleQuestionDelete(question.question_id, question.category_name, question.question_user_id_number, question.category_id, formId) }}>
                                <span> X </span>
                            </div>
                            {/* hide edit button for category bioData for original ParQ*/}
                            {(category != "Biodata" || formId != "0") && <i className="fa fa-edit mt-1  text-center" style={{ cursor: "pointer" }} onClick={() => {
                                setShowQuestionModal(true);
                                setQuestionToEdit(question);
                            }}> </i>}
                            {/* not a default form show drag handles */}
                            <div className={`ml-3`}>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id="message">
                                            drag up or down
                                        </Tooltip>
                                    }
                                >
                                    <i className="fas fa-grip-vertical" />
                                </OverlayTrigger>
                            </div>
                        </div>}
                </td>}
                {question.question_number /* && priorityFields[0]?.answer_type != "None"*/ ? <td style={{ borderBottom: "none" }} className={!isDragging ? `h-100 pt-2 d-flex justify-content-center align-items-center` : 'text-center'} >
                    <div > {questionNumber} </div> </td> :
                    <td>  </td>}
                <td  >
                    <p> {questionText} </p>
                    {
                        priorityFields.length > 0 && priorityFields.map(answerItem => {
                            let answerType;
                            if (answerItem.answer_type === "Numeric") {
                                answerType = "number"
                            } else if (answerItem.answer_type === "Textfield") {
                                answerType = "text"
                            } else {
                                answerType = answerItem.answer_type
                            }


                            let question_type = ["birthdate", "phone", "height", "height_units"
                                , "weight", "weight_units"].includes(answerItem.answer_values?.answer_id)
                                ? answerItem.answer_values?.answer_id : "standard"
                            return (
                                <>
                                    {(answerType === "Textarea") &&
                                        <textarea key={answerItem.answer_values?.answer_id}
                                            className="form-control form-control-sm"
                                            name={answerItem.answer_field_id}
                                            placeholder={answerItem.placeholder_text}
                                            disabled={completeStatus}
                                            onChange={(e) => {
                                                if (editingMode) return;

                                                let answer = e.target.value;
                                                //let category = question.category_name;
                                                let answer_field_id = answerItem.answer_field_id
                                                let client_id = clientId;
                                                let answer_id = answerItem.answer_values?.answer_id
                                                let integer_answer = 0;
                                                //let questionNumber = question.question_id;
                                                let payload = { client_id, question_type, answer, integer_answer, answer_field_id, answer_id }
                                                debouncedUpdateDB(payload)
                                            }}
                                        >
                                            {answerItem.answer_values?.answer}
                                        </textarea>}

                                    {(["Textfield", "Numeric", "Date"].includes(answerItem.answer_type)) &&
                                        <input key={answerItem.answer_values?.answer_id} type={answerType}
                                            className="form-control form-control-sm"
                                            name={answerItem.answer_field_id}
                                            placeholder={answerItem.placeholder_text}
                                            defaultValue={
                                                answerItem.answer_values?.answer ? answerItem.answer_values?.answer :
                                                    answerItem.answer_type == "Date" ? currentDate :
                                                        null}
                                            disabled={completeStatus}
                                            onChange={(e) => {

                                                if (editingMode) return;

                                                let answer = e.target.value;
                                                //let category = question.category_name;
                                                let answer_field_id = answerItem.answer_field_id
                                                let client_id = clientId;
                                                let answer_id = answerItem.answer_values?.answer_id
                                                let integer_answer = 0
                                                //let questionNumber = question.question_id;
                                                let payload = { client_id, question_type, answer, integer_answer, answer_field_id, answer_id }
                                                debouncedUpdateDB(payload)
                                            }}
                                            onBlur={(e) => {
                                                let answer_id = answerItem.answer_values?.answer_id
                                                if (answer_id === "birthdate") {
                                                    let answer = e.target.value;
                                                    let question_id = question.question_id;
                                                    let category = "Biodata";
                                                    let integer_answer = 0
                                                    let payload = { answer, category, answer_id, question_id, integer_answer };
                                                    dispatch(calcAge(payload))
                                                }
                                            }}
                                        />}
                                    {(["lbs=0,kg=1", "in=0,cm=1", "Never Taken=1,Normal=0,Abnormal=2"].includes(answerItem.answer_type)) &&
                                        <select className=" selectOption" style={{ width: "100%", padding: "5px" }}
                                            defaultValue={answerItem.answer_values?.answer}
                                            disabled={completeStatus}
                                            onChange={(e) => {
                                                if (editingMode) return;

                                                let answer = e.target.value;
                                                //let category = question.category_name;       
                                                let answer_field_id = answerItem.answer_field_id
                                                let client_id = clientId;
                                                let answer_id = answerItem.answer_values?.answer_id
                                                let integer_answer = 1
                                                //let questionNumber = question.question_id;
                                                let payload = { client_id, question_type, answer, integer_answer, answer_field_id, answer_id }
                                                debouncedUpdateDB(payload)

                                            }}
                                        >
                                            <option value="0">
                                                {(answerItem.answer_type === "lbs=0,kg=1") && "lbs"}
                                                {(answerItem.answer_type === "in=0,cm=1") && "inch"}
                                                {(answerItem.answer_type === "Never Taken=1,Normal=0,Abnormal=2") && "Normal"}
                                            </option>
                                            <option value="1">
                                                {(answerItem.answer_type === "lbs=0,kg=1") && "kg"}
                                                {(answerItem.answer_type === "in=0,cm=1") && "cm"}
                                                {(answerItem.answer_type === "Never Taken=1,Normal=0,Abnormal=2") && "Never Taken"}
                                            </option>
                                            {answerItem.answer_type === "Never Taken=1,Normal=0,Abnormal=2" &&
                                                <option value="2">
                                                    {(answerItem.answer_type === "Never Taken=1,Normal=0,Abnormal=2") && "Abnormal"}
                                                </option>
                                            }
                                        </select>
                                    }
                                    {answerItem.answer_type === "Hardcoded" &&
                                        <span className="ml-1">
                                            {answerItem.answer_values?.answer_id === "age" ? <small> <i>{answerItem.answer_values?.answer}  years old </i></small> :
                                                <b> {answerItem.answer_values?.answer} </b>}
                                        </span>
                                    }
                                    {answerItem.answer_type === "Signature" &&
                                        <div>
                                            <SignatureModal
                                                imgSrc={answerItem.answer_values?.answer}
                                                timeStamp={answerItem.answer_values?.time_stamp ? answerItem.answer_values?.time_stamp : null}
                                                editingMode={editingMode}
                                                clientId={clientId}
                                                answerItem={answerItem}
                                                debouncedUpdateDB={debouncedUpdateDB}
                                                question_type={question_type}
                                            />

                                        </div>
                                    }
                                </>)
                        })

                    }
                </td >
            </>
        )
    }

    function questionRender(question, questionNumber, category) {
        let priorityFields = [];

        let secondaryTypes = ["Yes=1,No=0", "Yes=1,No=0,Unsure=2"]

        for (let item of question.answer_array) {
            let answerType = item.answer_type;
            if (!secondaryTypes.includes(answerType)) priorityFields.push(item)
        }

        return (
            <>
                {priorityFieldsLoop(priorityFields, question, questionNumber, category)}

                {question.answer_array.map(answerItem => {
                    return (
                        <>
                            {(answerItem.answer_type === "Yes=1,No=0" || answerItem.answer_type === "Yes=1,No=0,Unsure=2") ?
                                <> <td >
                                    <input key={answerItem.id}
                                        type="radio"
                                        name={answerItem.answer_field_id}
                                        value="1"
                                        defaultChecked={answerItem.answer_values?.answer == "1" ? true : null}
                                        disabled={completeStatus}
                                        onChange={(e) => {
                                            if (editingMode) return;

                                            let answer = e.target.value;
                                            //let category = question.category_name;
                                            let answer_field_id = answerItem.answer_field_id
                                            let question_type = "standard"
                                            let client_id = clientId;
                                            let answer_id = answerItem.answer_id;
                                            let integer_answer = 1;
                                            //let questionNumber = question.question_id;
                                            let payload = { client_id, question_type, answer, integer_answer, answer_field_id, answer_id }
                                            debouncedUpdateDB(payload)

                                        }}

                                    />
                                </td>
                                    <td >
                                        <input key={answerItem.id}
                                            type="radio"
                                            value="0"
                                            defaultChecked={answerItem.answer_values?.answer === "0" ? true : null}
                                            name={answerItem.answer_field_id}
                                            disabled={completeStatus}
                                            onChange={(e) => {
                                                if (editingMode) return;

                                                let answer = e.target.value;
                                                //let category = question.category_name;
                                                let answer_field_id = answerItem.answer_field_id
                                                let question_type = "standard"
                                                let client_id = clientId;
                                                let answer_id = answerItem.answer_id;
                                                let integer_answer = 1
                                                //let questionNumber = question.question_id;
                                                let payload = { client_id, question_type, answer, integer_answer, answer_field_id, answer_id }
                                                debouncedUpdateDB(payload)

                                            }}
                                        />
                                    </td>
                                    {answerItem.answer_type === "Yes=1,No=0,Unsure=2" &&
                                        <td >
                                            <input key={answerItem.id}
                                                type="radio"
                                                value="2"
                                                defaultChecked={answerItem.answer_values?.answer === "2" ? true : null}
                                                name={answerItem.answer_field_id}
                                                disabled={completeStatus}
                                                onChange={(e) => {
                                                    if (editingMode) return;

                                                    let answer = e.target.value;
                                                    //let category = question.category_name;
                                                    let answer_field_id = answerItem.answer_field_id
                                                    let question_type = "standard"
                                                    let client_id = clientId;
                                                    let answer_id = answerItem.answer_id;
                                                    let integer_answer = 1
                                                    //let questionNumber = question.question_id;
                                                    let payload = { client_id, question_type, answer, integer_answer, answer_field_id, answer_id }
                                                    debouncedUpdateDB(payload)

                                                }}
                                            />
                                        </td>}
                                </>
                                :
                                null
                            }
                        </>
                    )
                })
                }

            </>
        )
    }

    const postNewFormOrganization = questions => {
        envAwarePost('api/customForms/',{
            action:'editFormOrganization',
            questions
        }).then(res=>{
            if(parseInt(defaultForm)){
                history.replace(`/formEditor?formId=${res.data.tgt_form_id}&clientId=edit`)
            }
            console.log(res)
        })
    }

    function handleDragEnd(results, singleForm) {
        const {source,destination} = results
        
        setIsDragging(false);
        if (!results.destination) return;
        let sourceKey = results.source.droppableId.split("-")[1];
        let destinationKey = results.destination.droppableId.split("-")[1];
        const updatedForm = JSON.parse(JSON.stringify(singleForm))
        let updatedOrderSource = JSON.parse(JSON.stringify(singleForm[sourceKey]));
        let updatedOrderDestination = JSON.parse(JSON.stringify(singleForm[destinationKey]));

        let [selectedRow] = updatedOrderSource.splice(results.source.index, 1);

        if (destinationKey !== sourceKey) {
            let destinationCategoryId = singleForm[destinationKey][0].category_id
            let destinationCategoryName = singleForm[destinationKey][0].category_name

            //update category id and name of moved question for local state
            selectedRow.category_id = destinationCategoryId;
            selectedRow.category_name = destinationCategoryName;
            updatedOrderDestination.splice(results.destination.index, 0, selectedRow);

            //update sequence  source
            let i = singleForm[sourceKey][0].question_sequence;
            updatedOrderSource.forEach( question => {
                question.question_sequence = i
                i += 1
            })

            //update sequence destination 
            let count = singleForm[destinationKey][0].question_sequence;
            updatedOrderDestination.forEach( question => {
                question.question_sequence = count
                count += 1
            })
            // LOCAL 
            //source
            dispatch(updateLocalSequence({ updatedOrder: updatedOrderSource, category: sourceKey }));

            //destination
            dispatch(updateLocalSequence({ updatedOrder: updatedOrderDestination, category: destinationKey }));

            updatedForm[sourceKey] = updatedOrderSource
            updatedForm[destinationKey] = updatedOrderDestination
            postNewFormOrganization(mapFormToQuestionSequence(updatedForm))


        } else {
            updatedOrderSource.splice(results.destination.index, 0, selectedRow);
            //update the form question sequence to reflect the new order
            let i = singleForm[sourceKey][0].question_sequence;
            updatedOrderSource.forEach(question => {
                question.question_sequence = i
                i += 1
            })

            dispatch(updateLocalSequence({ updatedOrder: updatedOrderSource, category: sourceKey }));

            let updateQuestions = updatedOrderSource.map((question, index) => (
                { question_id: question.question_id, question_sequence: question.question_sequence, question_number: index + 1 }
            ))

            updatedForm[sourceKey] = updatedOrderSource
            postNewFormOrganization(mapFormToQuestionSequence(updatedForm))

        }
    }

    const [isDragging, setIsDragging] = useState(false);


    function beforeDragStart(result) {
        setIsDragging(true);
    }

    const getListStyle = (isDragging) => {
        return {
            border: isDragging ? "5px solid grey" : "none",
        }
    };

    return (
        <div id="containerDiv" className={classes.printableArea2} >
        	{loadingForm ? <CenteredLoader /> :
	            <div id="formDownloadContainer" className={`${classes.print}`}>
	                <div className="d-flex justify-content-between">
	                    <h2 id="formTitle" className={`${classesForms.editorName} d-block hideForDownload`}
	                        style={{ textTransform: "capitalize" }}>
	                        <i> 
	                            {formTitle}
	                        </i>
	                         {completeStatus && 
                                <span 
                                    style={{ fontSize: "1.3rem" }} 
                                    className="ml-1 text-success"
                                > 
                                    (Complete) 
                                </span>
                            }
	                    </h2>
	                </div >




	                <div>

						{Object.entries(singleForm).map(([key, entries]) => {
	                            let yesNoType = false;
	                            let unsureType = false;
	                            // if no questions remaining in category, remove category
	                            if (singleForm[key].length < 1) return;

	                            //used to build table columns
	                            singleForm[key].forEach(item => {
	                                item.answer_array.forEach(answerItem => {
	                                    if (answerItem.answer_type_id === 1) {
	                                        yesNoType = true;
	                                    } else if (answerItem.answer_type_id === 2) {
	                                        unsureType = true;
	                                        yesNoType = true;
	                                    }
	                                })
	                            })

	                            return (
	                                <Table className=" table-bordered table-hover table-sm" >

	                                    <>
	                                        <thead >
	                                            <tr className="table-info">
	                                                {isTrainerOrGymEditing && <th style={{ textAlign: "center", width: "50px" }}>Options</th>}
	                                                <th style={{ textAlign: "center", width: "100px" }}>#</th>
	                                                <th style={{ textAlign: "center" }}>{key}
	                                                    {/* if its original ParQ with category bioData show this text*/}
	                                                    {key == "Biodata" && editingMode && formId != "0" &&
	                                                        <span className="ml-2" style={{ fontWeight: "normal" }}>
	                                                            (Linked to customer profile data)
	                                                        </span>}
	                                                </th>
	                                                {yesNoType && <th style={{ textAlign: "center", width: "80px" }}>Yes</th>}
	                                                {yesNoType && <th style={{ textAlign: "center", width: "80px" }}>No</th>}
	                                                {unsureType && <th style={{ textAlign: "center", width: "80px" }}>Unsure</th>}

	                                            </tr>
	                                        </thead>


                                            <tbody>

                                                {singleForm[key]?.map((question, index) => (
                                                    <tr
                                                        style={{ width: "100px" }}
                                                        key={(question.question_id * 1000)}
                                                    >
                                                        {questionRender(question, index + 1, key)}
                                                    </tr>
                                                ))}
                                            </tbody>
	                                    </>

	                                </Table>
	                            )

	                        })}


	                </div>
	                <div
	                    className={["my-2 text-md-right", classes.dataSavedNote,'hideForDownload'].join(' ')}
	                    variant="success">
	                    <i
	                        className="fas fa-info-circle mx-2 "
	                        style={{ color: "#525F7F" }}
	                    ></i>
	                    Data is automatically saved
	                </div>
	                {!completeStatus && !editingMode && <div
	                    className="mt-4 text-md-center"
	                    style={{ paddingBottom: "20px" }}
	                >
	                    <OverlayTrigger
	                        placement="top"
	                        overlay={
	                            <Tooltip id="message">
	                                You will no longer be able to edit this form.
	                            </Tooltip>
	                        }
	                    >
	                        <Button
	                            variant="outline-primary"
	                            onClick={() => setShowConfirmComplete(true)}
	                            className="hideForDownload w-50">
	                            Mark Form As Complete
	                        </Button>
	                    </OverlayTrigger>
	                </div>}
                    {completeStatus&&
                        <div className="text-right">
                            <small className="d-block">
                                You already compelted this form
                            </small>
                            <Button onClick={proceed} variant="outline-success">
                                {isLastForm?'Finish':'Proceed to Next Step'}
                            </Button>
                        </div>
                    }
	            </div >

           	}

            <Modal show={showConfirmComplete} onHide={() => setShowConfirmComplete(false)}>
                <Modal.Header>
                    <Modal.Title> Confirm Mark As Complete </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to mark this form as complete?
                    You will no longer be able to make any changes.
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => setShowConfirmComplete(false)} variant="secondary">
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleFormComplete}>
                        {loadFormComplete ? <Spinner size="sm" animation="border" role="status">
                            <span className="sr-only"> Loading...</span>
                        </Spinner> : "Mark As Complete"}
                    </Button>
                </Modal.Footer>
            </Modal>

        </div >

    )
}

const _TEST_PROGRAMS = [
    {
        "programID": 1600,
        "programName": "Program W/ All Packages"
    }
]


export function MultiFormsRoute({location}) {
    const dispatch = useDispatch()

    const params = new URLSearchParams(location.search)

    const formIds = (params.get('forms')||'').split(',').filter(id=>id!=='').map(v=>parseInt(v))
    const programIds = (params.get('programs')||'').split(',').filter(id=>id!=='').map(v=>parseInt(v))
    const redirect = params.get('redirect')

    const [assigningForms,setAssigningForms] = useState(true)
    const {status:formsStatus,map:formsMap} = useCustomForms()
    const {status:programsStatus,map:programsMap} = usePrograms()

    const forms = formsStatus==='idle'?formIds.map(id=>formsMap[id]):[]
    const programs = programsStatus==='loaded'?programIds.map(id=>programsMap[id]):[]

    useEffect(()=>{
        if(forms.length===0||!assigningForms) return 
        setAssigningForms(true)
        envAwarePost('api/customForms/',{
            action:'addFormsToClient',
            form_ids:forms.map(form=>form.form_id),
        }).then(()=>{
            setAssigningForms(false)
        })
    },[forms])

    const [showFinished,setShowFinisehd] = useState(false)


    const [formIdx,setFormIdx] = useState(0)

    const onHide = ()=>{
        window.alert('Please fill out the forms')
    }

    //if packages were purchased that had associated programs 
    //forward to the program assignemnt options
    const forwardToProgramPackageAssignment = programs => {
        //get all packages with these programs
        dispatch(updateProgramAssign({
            show:true,
            programs,
            redirect,
        }))
    }

    const proceed = ()=>{
        if(formIdx<forms.length-1){
            setFormIdx(idx=>idx+1)
        }else{
            setFormIdx(0)
            if(Boolean(programs)&&programs.length>0){
                setShowFinisehd(true)
                forwardToProgramPackageAssignment(programs)
            }else{
                window.location = `/${redirect}`
            }
        }
    }

    const message = 'Fill out these forms to complete your purchase'

    if(forms.length===0) return null
    if(showFinished) return (
        <div className="p-5 text-center">
            <strong>You've completed all the forms</strong>
        </div>
    )
    if(assigningForms) return (
        <div className="d-flex align-items-center justify-content-center p-5">
            <strong className="mr-2">Loading forms/waivers</strong> 
            <Spinner animation="border" size="sml"/>
        </div>
    )
    return (
        <div>
            <div className="text-center mb-2">
                {message}
            </div>
            <div>
                <div className="text-center mb-2">
                    <ButtonGroup>
                        {forms.map((_,i)=>(
                            <Button 
                                onClick={setFormIdx.bind(null,i)}
                                variant={
                                    i === formIdx
                                    ? "primary"
                                    : "outline-primary"
                                }
                                size="sm" 
                            >
                                {i+1}
                            </Button>
                        ))}
                    </ButtonGroup>
                </div>
                <div 

                    style={{maxWidth:'1000px',margin:'auto'}}
                >
                    <FormEditor 
                        form={forms[formIdx]} 
                        proceed={proceed}
                        isLastForm={formIdx===forms.length-1}
                    />
                </div>
            </div>
        </div>
    )
}

export default function MultiFormsModal(){
	const dispatch = useDispatch()
	const {show,forms,programs,clientId} = useMultiFormsModal()
	const [formIdx,setFormIdx] = useState(0)

	const onHide = ()=>{
		window.alert('Please fill out the forms')
	}

	const close = ()=>{
		dispatch(setMultiFormsModal({
			show:false,
			forms:[]
		}))
	}

	//if packages were purchased that had associated programs 
	//forward to the program assignemnt options
	const forwardToProgramPackageAssignment = programs => {
		//get all packages with these programs
		dispatch(updateProgramAssign({
			show:true,
			programs,
            clientId
		}))
	}

	const proceed = ()=>{
		if(formIdx<forms.length-1){
			setFormIdx(idx=>idx+1)
		}else{
			setFormIdx(0)
			close()
			if(Boolean(programs)&&programs.length>0){
				forwardToProgramPackageAssignment(programs)
			}
		}
	}
	const message = 'Fill out these forms to complete your purchase'
	if(forms.length===0) return null
	return (
		<Modal show={show} onHide={onHide} size="lg" centered>
			<Modal.Header>
				{message}
			</Modal.Header>
			<Modal.Body>
				<div className="text-center mb-1">
					<ButtonGroup>
						{forms.map((_,i)=>(
							<Button 
								onClick={setFormIdx.bind(null,i)}
								variant={
									i === formIdx
									? "primary"
									: "outline-primary"
								}
								size="sm" 
							>
								{i+1}
							</Button>
						))}
					</ButtonGroup>
				</div>
				<FormEditor 
                    clientId={clientId}
                    form={forms[formIdx]} 
                    proceed={proceed}
                    isLastForm={formIdx===forms.length-1}
                />
			</Modal.Body>
		</Modal>
	)
}